import React from 'react';
import THEME from '../utils/theme';
import SectionTag from '../components/SectionTag';
import useInView from '../hooks/useInView';

import { FaTrophy, FaCertificate, FaHandshake, FaLightbulb, FaLanguage, FaMoneyBillWave } from 'react-icons/fa';

const ITEMS = [
  { icon: FaTrophy,         color: '#BC002D', title: 'Experienced Instructors',  desc: 'Our teaching staff are trained in Japan and bring real-world industry expertise to every class.' },
  { icon: FaCertificate,    color: '#E6A817', title: 'Certified Credentials',    desc: 'All completed courses earn government-recognised and Japan-accredited certificates.' },
  { icon: FaHandshake,      color: '#006A4E', title: 'Placement Support',        desc: 'Full guidance and employer connections to help you secure a job in Japan.' },
  { icon: FaLightbulb,      color: '#5B8DEF', title: 'Modern Training Methods',  desc: 'Hands-on, practical training designed to work in real Japanese workplaces.' },
  { icon: FaLanguage,       color: '#E85D0A', title: 'Japanese Language',        desc: 'Structured language courses from JLPT N5 through N3 — taught by native-level instructors.' },
  { icon: FaMoneyBillWave,  color: '#8B6E3A', title: 'Affordable Fees',          desc: 'Flexible instalment plans make world-class training accessible to everyone.' },
];

export default function WhyUs() {
  const [ref, visible] = useInView();

  return (
    <section style={{ padding: '100px clamp(20px,4vw,40px)', background: 'white' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div ref={ref} className={`sk-fade-up ${visible ? 'sk-visible' : ''}`} style={{ textAlign: 'center', marginBottom: 60 }}>
          <SectionTag center>Why Choose Us</SectionTag>
          <h2 style={{ fontFamily: "'Syne', sans-serif", fontWeight: 800, fontSize: 'clamp(2rem,4vw,3.2rem)', lineHeight: 1.1, color: THEME.navy }}>
            What Sets Us Apart
          </h2>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 24 }}>
          {ITEMS.map((item, i) => {
            const Icon = item.icon;
            return (
              <div key={item.title}
                className={`sk-card-hover sk-fade-up ${visible ? 'sk-visible' : ''}`}
                style={{ transitionDelay: `${i * 0.08}s`, padding: '28px', borderRadius: 12, border: '1px solid #EDE7DE', background: 'white' }}>
                <div style={{
                  width: 52, height: 52, background: `${item.color}15`,
                  borderRadius: 12, display: 'flex', alignItems: 'center',
                  justifyContent: 'center', marginBottom: 18,
                }}>
                  <Icon size={24} color={item.color} />
                </div>
                <h4 style={{ fontFamily: "'Syne', sans-serif", fontSize: 17, fontWeight: 700, color: THEME.navy, marginBottom: 10 }}>
                  {item.title}
                </h4>
                <p style={{ fontSize: 14, color: '#6B7A8D', lineHeight: 1.75 }}>{item.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
